import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { OnboardingApprovalStatusRow } from "services/work-security-approvals.service";
import { approvalStatusSegments } from "./approvals-helpers";

/**
 * «Darbų sauga ✓ Rolandas 24.09 · Kibernetinis saugumas — laukia (Violeta)»
 * — the per-sphere approval state on the Personalas card.
 */
export default function ApprovalStatusLine({ rows }: { rows: OnboardingApprovalStatusRow[] }) {
  const { t } = useTranslation();
  const segments = approvalStatusSegments(rows);
  if (!segments.length) return null;
  return (
    <p className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-sm">
      <span className="text-gray-500">{t("ws_approvals_status_label")}:</span>
      {segments.map((segment, index) => (
        <React.Fragment key={segment.areaId || index}>
          {index > 0 && <span className="text-gray-300">·</span>}
          <span
            className={clsx(
              segment.status === "pending" ? "text-amber-800" : "text-green-800"
            )}
          >
            <span className="font-medium">{segment.areaName}</span>{" "}
            {segment.status === "approved" && (
              <>
                ✓{segment.detail ? ` ${segment.detail}` : ""}
              </>
            )}
            {segment.status === "auto_approved" && <>✓ {t("ws_approvals_auto")}</>}
            {segment.status === "pending" && (
              <>
                — {t("ws_approvals_waiting")}
                {segment.detail ? ` (${segment.detail})` : ""}
              </>
            )}
          </span>
        </React.Fragment>
      ))}
    </p>
  );
}
